module.exports = __webpack_public_path__ + "img/coin-CRO.0c23a8c3.svg";